// import React from "react";
// import { useState } from "react";
// import { Layout, Menu, Row, Col, Button } from "antd";
// import {
//   HomeOutlined,
//   ContactsOutlined,
//   InfoCircleOutlined,
//   AppstoreAddOutlined,
// } from "@ant-design/icons";
// import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";

// import HomePage from "./home";
// import AboutPage from "./about";
// import Logo1 from "../assests/images/Shivant hr consultancy (2).png";
// import { ReactComponent as Logo } from "../assests/images/WhatsApp-Image-2024-12-23-at-5.01.35-PM.svg";
// import ServicesPage from "./service/index";

// import ContactPage from "./contact/index";
//  import styles from "./company.module.scss"

// const { Header, Content, Footer } = Layout;

// const CompanyPage: React.FC = () => {
//     const [collapsed, setCollapsed] = useState(false);

//     const toggleCollapsed = () => {
//       setCollapsed(!collapsed);
//     };
//   return (
//     <Router>
//       <Layout 
//       style={{ backgroundColor: "black" ,width:"100%"}}
//       >
//         <Header
//           style={{
//             background: "#001529",
//             position: "sticky",
//             top: 0,
//             zIndex: 1,
//             width: "100%",
//             height:"120px",
//             display: "flex",
//             alignItems: "center",
//             gap: "18%",
//             padding:"0px"
//             //   justifyContent: 'space-between'
//           }}
          
//         >
//           <div style={{ display: "flex", alignItems: "center" ,width:"100%"}}>
//             <img src={Logo1} alt ="df"  className={styles["header-logo"]}/>
//             <p style={{ color: "#ffb859"}} className={styles["logo-text"]}>Shivant <span style={{color:"#23a9ff"}}>HR</span> Consultancy</p>
//           </div>
//           <Menu theme="dark" mode="horizontal" defaultSelectedKeys={["home"]}  inlineCollapsed={collapsed} style={{width:"100%"}}>
//             {/* <Menu.Item key="logo" icon={<Logo  width={30} height={30}/>}>
//             </Menu.Item> */}
//             <Menu.Item key="home" icon={<HomeOutlined />}>
//               <Link to="/home">Home</Link>
//             </Menu.Item>
//             <Menu.Item key="about" icon={<InfoCircleOutlined />}>
//               <Link to="/about">About</Link>
//             </Menu.Item>
//             <Menu.Item key="services" icon={<AppstoreAddOutlined />}>
//               <Link to="/services">Services</Link>
//             </Menu.Item>
//             <Menu.Item key="contact" icon={<ContactsOutlined />}>
//               <Link to="/contact">Contact</Link>
//             </Menu.Item>
//           </Menu>
//         </Header>

//         <Content style={{ padding: "0 20px", marginTop: 20 }}>
//           <div className="site-layout-content">
//             <Routes>
//               <Route path="/" element={<HomePage />} />
//               <Route path="/home" element={<HomePage />}/>
//               <Route path="/about" element={<AboutPage/>} />
//               <Route path="/services" element={<ServicesPage/>} />
//               <Route path="/contact" element={<ContactPage/>} />
//             </Routes>
//           </div>
//         </Content>

//         <Footer
//           style={{
//             backgroundColor: "#001529",
//             color: "white",
//             padding: "40px 80px",
//           }}
//         >
//           <Row gutter={[24, 24]}>
//             {/* About Us Section */}
//             <Col xs={24} md={6}>
//               <h3>About Us</h3>
//               <p>
//                 Shivant HR  Consultancy is a highly acclaimed recruitment and
//                 executive search company providing discerning talent recruitment
//                 services to a strong and large list of clients in all major
//                 cities across India.
//               </p>
//               <Button type="link" style={{ color: "white" }}>
//                 <Link to="/about">READ MORE +</Link>
//               </Button>
//             </Col>

//             {/* Quick Links Section */}
//             <Col xs={24} md={6}>
//               <h3>Quick Links</h3>
//               <ul style={{ listStyleType: "none", padding: 0 }}>
//                 <li style={{ padding: 6 }}>
//                   <Link to="/home" style={{ color: "white" }}>
//                     Home
//                   </Link>
//                 </li>
//                 <li style={{ padding: 6 }}>
//                   <Link to="/about" style={{ color: "white" }}>
//                     About us
//                   </Link>
//                 </li>
//                 <li style={{ padding: 6 }}>
//                   <Link to="/services" style={{ color: "white" }}>
//                     Services
//                   </Link>
//                 </li>
//                 <li style={{ padding: 6 }}>
//                   <Link to="/contact" style={{ color: "white" }}>
//                     Contact us
//                   </Link>
//                 </li>
//               </ul>
//             </Col>

//             {/* Our Services Section */}
//             <Col xs={24} md={6}>
//               <h3>Our Services</h3>
//               <ul style={{ listStyleType: "none", padding: 0 }}>
//                 <li style={{ padding: 6 }}>Leadership Hiring</li>
//                 <li style={{ padding: 6 }}>Permanent Staffing</li>
//                 <li style={{ padding: 6 }}>Contract Staffing</li>
//                 <li style={{ padding: 6 }}>Specialist Hiring</li>
//               </ul>
//             </Col>

//             {/* Contact Details Section */}
//             <Col xs={24} md={6}>
//               <h3>Contact Details</h3>
//               <p>
//                 3rd Floor, Dwarka Mor,New Delhi, 110059
//               </p>
//               <p>+91  7042500421, 7084398078</p>
//               <p>
//                 <a href="mailto:hr@sudhmura.com" style={{ color: "white" }}>
//                   sevices@shivanthrconsultancy.com
//                 </a>
//               </p>
//             </Col>
//           </Row>

//           <p style={{ marginTop: "30px", padding: 6 }}>
//              ©{new Date().getFullYear()} Shivant Hr Consultancy. All Rights Reserved.
//           </p>
//         </Footer>
//       </Layout>
//     </Router>
//   );
// };

// export default CompanyPage;



import React, { useState } from "react";
import { Layout, Menu, Drawer, Button, Grid, Col, Row } from "antd";
import {
  HomeOutlined,
  ContactsOutlined,
  InfoCircleOutlined,
  AppstoreAddOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";

import HomePage from "./home";
import AboutPage from "./about";
import ServicesPage from "./service/index";
import ContactPage from "./contact/index";

import Logo1 from "../assests/images/Shivant hr consultancy (2).png";
import styles from "./company.module.scss";

const { Header, Content, Footer } = Layout;
const { useBreakpoint } = Grid;

const CompanyPage: React.FC = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const screens = useBreakpoint();

  const showDrawer = () => setDrawerVisible(true);
  const onClose = () => setDrawerVisible(false);

  const menuItems = [
    {
      key: "home",
      icon: <HomeOutlined />,
      label: <Link to="/home">Home</Link>,
    },
    {
      key: "about",
      icon: <InfoCircleOutlined />,
      label: <Link to="/about">About</Link>,
    },
    {
      key: "services",
      icon: <AppstoreAddOutlined />,
      label: <Link to="/services">Services</Link>,
    },
    {
      key: "contact",
      icon: <ContactsOutlined />,
      label: <Link to="/contact">Contact</Link>,
    },
  ];

  return (
    <Router>
      <Layout style={{ backgroundColor: "black", width: "100%" }}>
        <Header
          style={{
            background: "#001529",
            position: "sticky",
            top: 0,
            zIndex: 1000,
            width: "100%",
            height: "120px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 20px",
          }}
        >
          {/* Logo */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={Logo1}
              alt="Logo"
              className={styles["header-logo"]}
              style={{ maxHeight: "80px" }}
            />
            <p style={{ color: "#ffb859" }} className={styles["logo-text"]}>
              Shivant <span style={{ color: "#23a9ff" }}>HR</span> Consultancy
            </p>
          </div>

          {/* Desktop menu */}
          {screens.md ? (
            <Menu
              theme="dark"
              mode="horizontal"
              defaultSelectedKeys={["home"]}
              style={{ lineHeight: "64px" }}
              items={menuItems}
            />
          ) : (
            <>
              {/* Hamburger icon for mobile */}
              <Button
                className="menu-button"
                type="text"
                icon={<MenuOutlined style={{ fontSize: "24px", color: "white" }} />}
                onClick={showDrawer}
              />
              {/* Mobile Drawer */}
              <Drawer
                title="Menu"
                placement="right"
                closable
                onClose={onClose}
                open={drawerVisible}
                className="mobile-drawer"
                drawerStyle={{ backgroundColor: "#001529" }} // <-- Black background
                headerStyle={{ backgroundColor: "#001529", color: "#fff" }} // Optional: black header
                bodyStyle={{ color: "#fff" }} // Optional: white text
              >
                <Menu
                theme="dark"
                  mode="vertical"
                  items={menuItems}
                  onClick={onClose}
                />
              </Drawer>
            </>
          )}
        </Header>

        {/* Page Content */}
        <Content style={{ padding: "0 20px", marginTop: 20 }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </Content>

        {/* Footer (optional) */}
        <Footer
          style={{
            backgroundColor: "#001529",
            color: "white",
            padding: "40px 80px",
          }}
        >
          <Row gutter={[24, 24]}>
            {/* About Us Section */}
            <Col xs={24} md={6}>
              <h3>About Us</h3>
              <p>
                Shivant HR  Consultancy is a highly acclaimed recruitment and
                executive search company providing discerning talent recruitment
                services to a strong and large list of clients in all major
                cities across India.
              </p>
              <Button type="link" style={{ color: "white" }}>
                <Link to="/about">READ MORE +</Link>
              </Button>
            </Col>

            {/* Quick Links Section */}
            <Col xs={24} md={6}>
              <h3>Quick Links</h3>
              <ul style={{ listStyleType: "none", padding: 0 }}>
                <li style={{ padding: 6 }}>
                  <Link to="/home" style={{ color: "white" }}>
                    Home
                  </Link>
                </li>
                <li style={{ padding: 6 }}>
                  <Link to="/about" style={{ color: "white" }}>
                    About us
                  </Link>
                </li>
                <li style={{ padding: 6 }}>
                  <Link to="/services" style={{ color: "white" }}>
                    Services
                  </Link>
                </li>
                <li style={{ padding: 6 }}>
                  <Link to="/contact" style={{ color: "white" }}>
                    Contact us
                  </Link>
                </li>
              </ul>
            </Col>

            {/* Our Services Section */}
            <Col xs={24} md={6}>
              <h3>Our Services</h3>
              <ul style={{ listStyleType: "none", padding: 0 }}>
                <li style={{ padding: 6 }}>Leadership Hiring</li>
                <li style={{ padding: 6 }}>Permanent Staffing</li>
                <li style={{ padding: 6 }}>Contract Staffing</li>
                <li style={{ padding: 6 }}>Specialist Hiring</li>
              </ul>
            </Col>

            {/* Contact Details Section */}
            <Col xs={24} md={6}>
              <h3>Contact Details</h3>
              <p>
                3rd Floor, Dwarka Mor,New Delhi, 110059
              </p>
              <p>+91  7042500421, 7084398078</p>
              <p>
                <a href="mailto:hr@sudhmura.com" style={{ color: "white" }}>
                  sevices@shivanthrconsultancy.com
                </a>
              </p>
            </Col>
          </Row>

          <p style={{ marginTop: "30px", padding: 6 }}>
             ©{new Date().getFullYear()} Shivant Hr Consultancy. All Rights Reserved.
          </p>
        </Footer>
        {/* <Footer style={{ textAlign: "center", color: "#ccc" }}>
          © {new Date().getFullYear()} Shivant HR Consultancy. All rights reserved.
        </Footer> */}
      </Layout>
    </Router>
  );
};

export default CompanyPage;
